import React, { useState } from "react";
import "./BookingSideBar.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import images from "../../../../Utils/importImages";
import Popup from "./BookingPopup";
import Invoice from "../Invoice";
import WebCheckin from "../WebCheckin";
import EmailTicket from "../EmailTicket";
import TicketFormat from "../TicketFormat";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactDOMServer from "react-dom/server";
import ReactDOM from "react-dom/client";
import toast from "react-hot-toast";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import { MAIN_URL } from "../../../../Configs/Urls";
import CancellationForm from "./CancellationForm";
import ReschedulingForm from "./ReschedulingForm";
import RaisedRequests from "./RaisedRequests";
import Popup1 from "../../../Components/Popups/ModalPopup/Popup1";

function BookingSideBar({ WebsiteLinks, SidebarOptions }) {
  let dispatch = useDispatch();

  const { isUserLogin, isAdminLogin, userLoggedInData } = useSelector(
    (state) => state.user
  );

  console.log("userLoggedInData is : ", userLoggedInData);

  let navigate = useNavigate();

  let getTwoLetterName = () => {
    let name =
      isUserLogin == true
        ? `${userLoggedInData?.user_data?.first_name} ${userLoggedInData?.user_data?.last_name == null
          ? ""
          : userLoggedInData?.user_data?.last_name
        }`
        : userLoggedInData?.fullName;

    let splitted = name.split(" ");

    let returnName = splitted.map((item) => item.charAt(0));

    return returnName;
  };

  let getName = () => {
    let name =
      isUserLogin == true
        ? `${userLoggedInData?.user_data?.first_name} ${userLoggedInData?.user_data?.last_name == null
          ? ""
          : userLoggedInData?.user_data?.last_name
        }`
        : userLoggedInData?.fullName;
    return name;
  };

  let getContactInfo = () => {
    let credential =
      isUserLogin == true
        ? userLoggedInData?.auth_prime == "email"
          ? userLoggedInData?.email
          : userLoggedInData?.phone
        : userLoggedInData?.email;
    return credential;
  };

  // Instead of manually linking CSS, copy all stylesheets
  const stylesheets = Array.from(document.styleSheets)
    .map((sheet) => {
      try {
        return Array.from(sheet.cssRules)
          .map((rule) => rule.cssText)
          .join("\n");
      } catch (e) {
        // Handle cross-origin stylesheets
        return "";
      }
    })
    .join("\n");

  const downloadTicket = async (data) => {
    let popup = null;
    let root = null;

    try {
      toast.loading("Generating PDF...", { id: "pdf-download" });

      // Open a popup window
      popup = window.open("", "_blank", "width=1200,height=800");

      if (!popup) {
        throw new Error("Popup blocked. Please allow popups for this site.");
      }

      // Setup the popup document
      popup.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Generating Ticket PDF...</title>
          <style>${stylesheets}</style>
        </head>
        <body>
          <div id="ticket-root"></div>
        </body>
      </html>
    `);
      popup.document.close();

      // Wait for popup to load
      await new Promise((resolve) => {
        if (popup.document.readyState === "complete") {
          resolve();
        } else {
          popup.addEventListener("load", resolve);
        }
      });

      // Render TicketFormat in the popup
      const container = popup.document.getElementById("ticket-root");
      root = ReactDOM.createRoot(container);

      await new Promise((resolve) => {
        root.render(<TicketFormat Data={data} nav={null} />);
        setTimeout(resolve, 1000); // Wait for render
      });

      // Wait for fonts and images
      await popup.document.fonts.ready;
      await new Promise((resolve) => setTimeout(resolve, 1500));

      // Get the ticket element from popup
      const ticketElement = popup.document.querySelector(".air-ticket-view");

      if (!ticketElement) {
        throw new Error("Ticket element not found in popup");
      }

      // Generate canvas from popup content
      const canvas = await html2canvas(ticketElement, {
        scale: 2,
        useCORS: true,
        allowTaint: false,
        logging: false,
        backgroundColor: "#ffffff",
        width: ticketElement.offsetWidth,
        height: ticketElement.offsetHeight,
        windowWidth: ticketElement.offsetWidth,
        windowHeight: ticketElement.offsetHeight,
      });

      if (canvas.width === 0 || canvas.height === 0) {
        throw new Error("Generated canvas is empty");
      }

      // Convert to PDF
      const imgData = canvas.toDataURL("image/png", 1.0);
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const ratio = canvasWidth / canvasHeight;
      const width = pdfWidth;
      const height = pdfWidth / ratio;

      let heightLeft = height;
      let position = 0;

      // Add first page
      pdf.addImage(imgData, "PNG", 0, position, width, height);
      heightLeft -= pdfHeight;

      // Add more pages if needed
      while (heightLeft > 0) {
        position = heightLeft - height;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, width, height);
        heightLeft -= pdfHeight;
      }

      // Save PDF
      const bookingId = data.Booking_id || "ticket";
      const fileName = `Ticket_${bookingId}_${moment().format("DDMMYYYY")}.pdf`;
      pdf.save(fileName);

      toast.success("PDF downloaded successfully!", { id: "pdf-download" });
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error(`Failed to generate PDF: ${error.message}`, {
        id: "pdf-download",
      });
    } finally {
      // Cleanup: close popup
      if (root) {
        root.unmount();
      }
      if (popup && !popup.closed) {
        popup.close();
      }
    }
  };

  let [openCancellationPopup, setOpenCancellationPopup] = useState(null);
  let [openReschedulingPopup, setOpenReschedulingPopup] = useState(null);
  let [openAddonsPopup, setOpenAddonsPopup] = useState(null);
  let [openRaisedRequestsBookingId, setOpenRaisedRequestsBookingId] = useState(null);

  let [openEmailTicketPopup, setOpenEmailTicketPopup] = useState(false);

  let [emailData, setEmailData] = useState(null);
  let closeTheEmailTicketPopup = () => {
    setEmailData(null);
    setOpenEmailTicketPopup(false);
  };

  let openTheEmailTicket = (data) => {
    setEmailData(data);
    setOpenEmailTicketPopup(true);
  };

  let [openInvoicePopup, setOpenInvoicePopup] = useState(false);

  let [invoiceData, setInvoiceData] = useState(null);

  let closeTheInvoicePopup = () => {
    setInvoiceData(null);
    setOpenInvoicePopup(false);
  };

  let openTheInvoice = (data) => {
    setInvoiceData(data);
    setOpenInvoicePopup(true);
  };

  let [openCheckinPopup, setOpenCheckinPopup] = useState(false);

  let [CheckinData, setCheckinData] = useState(null);

  let closeTheCheckinPopup = () => {
    setCheckinData(null);
    setOpenCheckinPopup(false);
  };

  let openTheWebCheckin = (data) => {
    setCheckinData(data);
    setOpenCheckinPopup(true);
  };

  const printTicket = (data) => {
    const printWindow = window.open("", "_blank", "width=800,height=600");

    // Collect all stylesheets from the current document
    const styles = Array.from(document.styleSheets)
      .map((sheet) => {
        try {
          if (sheet.href) {
            return `<link rel="stylesheet" href="${sheet.href}" />`;
          } else if (sheet.ownerNode && sheet.ownerNode.innerHTML) {
            return `<style>${sheet.ownerNode.innerHTML}</style>`;
          }
        } catch (e) {
          console.warn("Style sheet couldn't be loaded:", e);
          return "";
        }
      })
      .join("\n");

    const htmlContent = `
        <html>
          <head>
            <title>Print Ticket</title>
            ${styles}
          </head>
          <body>
            <div id="print-ticket-root"></div>
            <script>
              window.onload = function () {
                setTimeout(() => {
                  window.print();
                  window.close();
                }, 1000);
              };
            </script>
          </body>
        </html>
      `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();

    // Wait for window to finish loading before injecting React
    const interval = setInterval(() => {
      const rootEl = printWindow.document.getElementById("print-ticket-root");
      if (rootEl) {
        const root = ReactDOM.createRoot(rootEl);
        root.render(<TicketFormat Data={data} nav={null} />);
        clearInterval(interval);
      }
    }, 100);
  };

  console.log("SidebarOptions us : ", SidebarOptions);

  return (
    <>
      <aside className="userdb-aside">
        <div className="userdb-logged-user">
          <div className="userdb-username-tag">{getTwoLetterName()}</div>
          <div className="userdb-username-info">
            <div className="userdb-uname">{getName()}</div>
            <div className="userdb-email">{getContactInfo()}</div>
          </div>
        </div>

        <div className="userdb-left-fb">
          <div className="element">
            <div className="bar"></div>
            <img src={images["flight-bookings-icon.svg"]} alt="" srcset="" />
            <div className="proxima_semibold color_dark-purple font16">
              My Flight Bookings
            </div>
          </div>
        </div>
        <ul className="userdb-left-panel booking-sidebar">
          {SidebarOptions?.map((option, id) => {
            return (
              <li
                className={option.classname}
                onClick={() => {

                  console.log("option si : ", option);

                  if (option.action == "download") {
                    downloadTicket(option.Data.data);
                  } else if (option.action == "print") {
                    let DataToSend = SidebarOptions.filter(
                      (item) => item.name == "Download E-Ticket"
                    )[0].Data.data;
                    printTicket(DataToSend);
                  } else if (option.action == "email") {
                    let DataToSend = SidebarOptions.filter(
                      (item) => item.name == "Download E-Ticket"
                    )[0].Data.data;

                    openTheEmailTicket(DataToSend);
                  } else if (
                    option.action == "popup" &&
                    option.name == "Invoice"
                  ) {
                    openTheInvoice(option?.Data || option?.data);
                    // openpopup // open the popup and sned email
                  } else if (
                    option.action == "popup" &&
                    option.name == "Cancel Booking"
                  ) {
                    setOpenCancellationPopup(option?.Data || option?.data);
                    // openpopup // open the popup and sned email
                  } else if (
                    option.action == "popup" &&
                    option.name == "Add Addons Booking"
                  ) {
                    setOpenAddonsPopup(option?.Data || option?.data);
                  } else if (
                    option.action == "popup" &&
                    option.name == "Reschedule Booking"
                  ) {


                    setOpenReschedulingPopup(option?.Data || option?.data);
                    // openpopup // open the popup and sned email
                  } else if (
                    option.action == "popup" &&
                    option.name == "Raised Requests"
                  ) {
                    setOpenRaisedRequestsBookingId(option?.Data?.bookingId || null);
                  } else if (option.action == "redirect") {
                    let DataToSend = SidebarOptions.filter(
                      (item) => item.name == "Download E-Ticket"
                    )[0].Data.data;

                    openTheWebCheckin(DataToSend);

                    // openpopup // open the popup and sned email
                  }
                }}
              >
                {option.name}
              </li>
            );
          })}
        </ul>
      </aside>

      <Popup
        Open={openEmailTicketPopup}
        onClose={closeTheEmailTicketPopup}
        component={
          <EmailTicket Data={emailData} onClose={closeTheEmailTicketPopup} />
        }
      />

      <Popup1
        Open={!!openCancellationPopup}
        onClose={() => setOpenCancellationPopup(null)}
        Content={
          <CancellationForm
            showbottombar={true}
            autoFill={{ autoFilled: false }}
            getApi={`${MAIN_URL}bookings/flights/get-cancellation-form`}
            postApi={`${MAIN_URL}bookings/flights/move-to-booking/cancellation-v1`}
            booking_id={openCancellationPopup?.bookingId}
            onClose={() => setOpenCancellationPopup(null)}
          />
        }
      />

      <Popup1
        Open={!!openReschedulingPopup}
        onClose={() => setOpenReschedulingPopup(null)}
        Content={
          <ReschedulingForm
            showbottombar={true}
            autoFill={{ autoFilled: false }}
            getApi={`${MAIN_URL}bookings/flights/get-rescheduling-form`}
            postApi={`${MAIN_URL}bookings/flights/move-to-booking/rescheduling-v1`}
            booking_id={openReschedulingPopup?.bookingId}
            onClose={() => setOpenReschedulingPopup(null)}
          />
        }
      />

      <Popup1
        Open={!!openAddonsPopup}
        onClose={() => setOpenAddonsPopup(null)}
        Content={
          <ReschedulingForm
            showbottombar={true}
            autoFill={{ autoFilled: false }}
            getApi={`${MAIN_URL}bookings/flights/get-rescheduling-form`}
            postApi={`${MAIN_URL}bookings/flights/move-to-booking/rescheduling-v1`}
            booking_id={openAddonsPopup?.bookingId}
            onClose={() => setOpenAddonsPopup(null)}
            ancillaryOnly={true}
          />
        }
      />


      <Popup1
        Open={!!openRaisedRequestsBookingId}
        onClose={() => setOpenRaisedRequestsBookingId(null)}
        Content={
          <RaisedRequests
            booking_id={openRaisedRequestsBookingId}
            onClose={() => setOpenRaisedRequestsBookingId(null)}
          />
        }
      />

      <Popup
        Open={openCheckinPopup}
        onClose={closeTheCheckinPopup}
        component={
          <WebCheckin
            Data={CheckinData}
            links={WebsiteLinks}
            onClose={closeTheCheckinPopup}
          />
        }
      />

      <Popup
        Open={openInvoicePopup}
        onClose={closeTheInvoicePopup}
        component={
          <Invoice Data={invoiceData} onClose={closeTheInvoicePopup} />
        }
      />
    </>
  );
}

export default BookingSideBar;
